import React from "react";
import RoleProgress from "../../progressBar/RoleProgress";

const SetPermissions = ({
  id,
  closePermissionsModal,
  permissionsModalOpen,
  openReviewPermissionsModal,
  openModal,
  modules,
  selectedPermissions,
  setSelectedPermissions,
}) => {
  const handleCheckboxChange = (permissionId) => {
    const isSelected = selectedPermissions.includes(permissionId);

    if (isSelected) {
      // If permission is already selected, remove it
      setSelectedPermissions((prevSelected) =>
        prevSelected.filter((id) => id !== permissionId)
      );
    } else {
      // If permission is not selected, add it
      setSelectedPermissions((prevSelected) => [...prevSelected, permissionId]);
    }
  };

  const handleNextButtonClick = () => {
    closePermissionsModal();
    openReviewPermissionsModal();
  };

  const handleBackButtonClick = () => {
    closePermissionsModal();
    openModal();
  };
  return (
    <div
      id={id}
      className={`${
        permissionsModalOpen ? "flex" : "hidden"
      } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
    >
      <div className="relative flex fixed min-h-[80%] w-[65%]">
        <div className="relative flex-col flex bg-white shadow w-full mx-auto">
          <div
            onClick={closePermissionsModal}
            className="flex items-center justify-end p-2 cursor-pointer"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.74039 11.1602L5.60039 8.06016L3.80039 11.1602H0.100391L3.78039 5.46016L0.000390632 0.000155687H3.84039L5.98039 3.08016L7.78039 0.000155687H11.4804L7.74039 5.62016L11.5804 11.1602H7.74039Z"
                fill="black"
              />
            </svg>
          </div>
          <div className="flex">
            <div className=" w-[28vw]">
              <div className="py-2 rounded-t">
                <p className="text-[20px] font-bold text-[#000] ml-5">
                  Create a new role
                </p>
              </div>
              <div className="mt-6 px-6">
                <RoleProgress step={2} />
              </div>
            </div>
            <div className="w-[72vw] flex flex-col mt-5 justify-between">
              <div>
                <div className="mt-5 mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Set Permissions
                  </p>
                  <div className="text-[#000] mt-2 text-sm font-normal ">
                    <p>
                      Set permissions for the role you have just entered to
                      ensure precise access control.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col gap-[10px] justify-between mt-6 mr-4">
                  <p className="text-[#000] font-bold">Select Permissions</p>
                  <div className="h-[50vh] w-[90%] border-[1px] border-[#000000] p-3 overflow-y-auto">
                    {modules &&
                      modules?.map((module) => (
                        <div key={module?.id}>
                          <p className="text-[#000] font-bold">
                            {module?.name}
                          </p>
                          {module?.permissions?.map((permission) => (
                            <div
                              className="w-full flex items-center mt-3"
                              key={permission.id}
                            >
                              <div className="w-[65%] mb-5">
                                <p className="pl-5">{permission?.name}</p>
                              </div>
                              <div className="w-[35%] mb-5 flex justify-center">
                                <input
                                  type="checkbox"
                                  className="custom-checkbox"
                                  checked={selectedPermissions?.includes(
                                    permission?.id
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(permission?.id)
                                  }
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="flex w-[88%] items-center justify-between mt-12 mb-8 pr-[15px]">
                <div className="flex items-center justify-between gap-[20px] w-[16vw]">
                  <button
                    onClick={handleBackButtonClick}
                    data-modal-toggle={id}
                    type="button"
                    className="text-[#000] bg-[#8ED6A8] hover:bg-[#8ED6A8] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Back
                  </button>
                  <button
                    onClick={handleNextButtonClick}
                    data-modal-toggle={id}
                    type="button"
                    className="text-white bg-[#005C53] hover:bg-[#005C53] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Next
                  </button>
                </div>
                <button
                  onClick={closePermissionsModal}
                  data-modal-toggle={id}
                  type="button"
                  className="text-gray-500 bg-[#D9D9D9] hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-[5px] border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetPermissions;
